import React from "react";
import * as C from "./styles";

const Header = () => {
    return (
        <C.Container>
            <C.Header>
                <C.Tittle>FinançasPro</C.Tittle>

            </C.Header>
        </C.Container>

    )
}

export default Header;